import React from 'react';

class ErrorBoundary extends React.Component<any,any> {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false,
      errorMessage: 'Please reload',
    };
  }

  componentDidCatch(error, info) {
    this.setState({ hasError: true, errorMessage: error });
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="d-flex align-items-center justify-content-center" style={{height:window.innerHeight}}>
          <h1 className='mb-0 mr-3'>{this.state.errorMessage}</h1>
          <i className='fas fa-redo-alt text-dark' style={{fontSize:24}}></i>
        </div>
      );
    } else {
      return this.props.children;
    }
  }
}

export default ErrorBoundary;
